import { useState, useRef, useEffect } from "react";

import {
  TaskSelector,
  TaskInExectution,
  TaskDelayed,
  TaskPending,
  TaskConcluded,
  TaskUnderline,
} from "./styles";

const TaskStatusSelector = ({ params, type, setType }) => {
  const [underlineWidth, setUnderlineWidth] = useState(0);
  const [underlineLeft, setUnderlineLeft] = useState(0);

  const handleResize = () => {

    if (params.get('status') === 'doing' || params.get('status') === "" || params.get('status') === null) {
      setUnderlineWidth(executionRef.current?.clientWidth);
      setUnderlineLeft(executionRef.current?.offsetLeft);
    }else if (params.get('status') === 'late' || type.status === "late") {
      setUnderlineWidth(delayedRef.current?.clientWidth);
      setUnderlineLeft(delayedRef.current?.offsetLeft);
    }else if (params.get('status') === 'pending' || type.status === "pending") {
      setUnderlineWidth(pendingRef.current?.clientWidth);
      setUnderlineLeft(pendingRef.current?.offsetLeft);
    }else if (params.get('status') === 'done' || type.status === "done") {
      setUnderlineWidth(concludedRef.current?.clientWidth);
      setUnderlineLeft(concludedRef.current?.offsetLeft);
    }
  };

  useEffect(() => {
    handleResize(); // Initial calculation on component mount

    window.addEventListener("resize", handleResize); // Add resize event listener

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener on component unmount
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const executionRef = useRef(null);
  const delayedRef = useRef(null);
  const pendingRef = useRef(null);
  const concludedRef = useRef(null);


  return (
    <TaskSelector>
      <TaskInExectution
        TaskSelectorState={params.get('status') ? params.get('status') :  type.status}
        onClick={() => {
          if (params.get('status') !== "doing")
            setType({ ...type, status: "doing", page: 1 });
        }}
        ref={executionRef}
      >
        Em Execução
      </TaskInExectution>
      <TaskDelayed
        TaskSelectorState={params.get('status')}
        onClick={() => {
          if (params.get('status') !== "late")
            setType({ ...type, status: "late", page: 1 });
        }}
        ref={delayedRef}
      >
        Atrasadas
      </TaskDelayed>
      <TaskPending
        TaskSelectorState={params.get('status')}
        onClick={() => {
          if (params.get('status') !== "pending")
            setType({ ...type, status: "pending", page: 1 });
        }}
        ref={pendingRef}
      >
        Pendentes
      </TaskPending>
      <TaskConcluded
        TaskSelectorState={params.get('status')}
        onClick={() => {
          if (params.get('status') !== "done")
            setType({ ...type, status: "done", page: 1 });
        }}  
        ref={concludedRef}
      >
        Concluídas
      </TaskConcluded>
      <TaskUnderline
        style={{
          left: `${underlineLeft}px`,
          width: `${underlineWidth}px`,
        }}
      />
    </TaskSelector>
  );
};

export default TaskStatusSelector;
